module.exports = __webpack_public_path__ + "assets/eye.e4fe315c.svg";